import Alpine from "alpinejs";
// @ts-ignore
import intersect from "@alpinejs/intersect";
import * as d3 from "d3";

import horizontalBarChart from "./horizontalBarChart";
import proportionalCircleChart from "./proportionalCircleChart";
import simpleDonutChart from "./simpleDonutChart";
import { calcBoundedLimit } from "./utils";
import horizontalStackedChart from "./horizontalStackedChart";
import complexeDonutChart from "./complexeDonutChart";
import scatterPlotChart from "./scatterPlotChart";
// @ts-ignore
window.Alpine = Alpine;
window.d3 = d3;
Alpine.plugin(intersect);

// Polyfill pour faire fonctionner les tags `template`
// dans les tags `svg`
(function () {
  var templates = document.querySelectorAll("svg template");
  var el, template, attribs, attrib, count, child, content;
  for (var i = 0; i < templates.length; i++) {
    el = templates[i];
    template = el.ownerDocument.createElement("template");
    el.parentNode?.insertBefore(template, el);
    attribs = el.attributes;
    count = attribs.length;
    while (count-- > 0) {
      attrib = attribs[count];
      template.setAttribute(attrib.name, attrib.value);
      el.removeAttribute(attrib.name);
    }
    el.parentNode?.removeChild(el);
    content = template.content;
    while ((child = el.firstChild)) {
      content.appendChild(child);
    }
  }
})();

Alpine.store("responsive", {
  init() {
    // get the screens from tailwind.config.js
    const screens = {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px",
    };
    // fill mediaQueries object with screens from tailwind.config.js
    Object.keys(screens).map((screen) => {
      // create matchMedia
      let mm = window.matchMedia(`(min-width:${screens[screen]})`);

      // add listener, to dispatch event every time it changes
      mm.addEventListener("change", (e) =>
        window.dispatchEvent(
          new CustomEvent("matchmedia-changed", {
            detail: {
              screen: screen,
              media: e.media,
              matches: e.matches,
            },
          })
        )
      );
      window.dispatchEvent(
        new CustomEvent("matchmedia-changed", {
          detail: {
            screen: screen,
            media: mm.media,
            matches: mm.matches,
          },
        })
      );

      // add matchMedia to mediaQueries object
      this["mediaQueries"].set(screen, mm);
    });
  },
  matching(
    /** @type {Record<'default' | 'sm' | 'md' | 'lg' | 'xl' | '2xl', number | string>} */ sizes
  ) {
    const mm = [...this["mediaQueries"].entries()]
      .filter(([, v]) => v.matches)
      .map(([k]) => k)
      .reverse();
    const size = mm.find((k) => sizes[k] !== undefined);

    return size ? sizes[size] : sizes["default"];
  },
  mediaQueries: new Map(),
});

window["createHorizontalBarChart"] = horizontalBarChart;
window["createProportionalCircleChart"] = proportionalCircleChart;
window["createHorizontalStackedChart"] = horizontalStackedChart;
window["createSimpleDonutChart"] = simpleDonutChart;
window["createComplexeDonutChart"] = complexeDonutChart;
window["calcBoundedLimit"] = calcBoundedLimit;
window["createScatterPlotChart"] = scatterPlotChart;

window["formatChiffre"] = (/** @type {number} */ n) =>
  n >= 1000000
    ? n
        .toLocaleString("fr", {
          notation: "compact",
          compactDisplay: "long",
          minimumFractionDigits: 1,
        })
        .split(/\s/)
    : [n.toString()];

document.addEventListener("alpine:initialized", () => {
  Alpine.store("responsive")["mediaQueries"].forEach((e, screen) => {
    const event = new CustomEvent("matchmedia-changed", {
      detail: {
        screen,
        media: e.media,
        matches: e.matches,
      },
    });
    window.dispatchEvent(event);
  });
});
Alpine.start();
